import { createFileRoute } from "@tanstack/react-router";
import { Breadcrumbs, TrashView } from "../../components/media";
import { MediaType } from "../../generated/graphql";
import { useAppSelector } from "../../store";

export const Route = createFileRoute("/media/audio/trash")({
  component: AudioTrashPage,
});

function AudioTrashPage() {
  const selectedFolderId = useAppSelector((state) => state.media.selectedFolderId);

  return (
    <div className="space-y-6 lg:p-[1%]">
      {/* Breadcrumbs */}
      <Breadcrumbs
        currentFolderId={selectedFolderId}
        mediaType={MediaType.Audio}
        rootLabel="Audio"
        showTrash={true}
      />

      {/* Trash View - shows trashed items from current folder context */}
      <TrashView folderId={selectedFolderId} mediaType={MediaType.Audio} />
    </div>
  );
}
